let React      = require('react');
// -------------------------------------------------------

class Loading extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      first_flg : this.props.flg,
      active    : false,
    };
  }
  // -------------------------------------------------------
  
  UNSAFE_componentWillReceiveProps(nextProps) {
    if( nextProps.flg != this.state.first_flg ) this.setState({ active: true });
  }
  // -------------------------------------------------------
  
  render() {
    if( this.state.active == false && this.props.forced == undefined ) return null;
    
    // サブローディング処理
    let loading_class = (this.props.flg) ? 'true' : 'false';
    return (
      <div className={'sub-loading '+ loading_class}>
        <div className="sk-circle">
          <div className="sk-circle1 sk-child"></div>
          <div className="sk-circle2 sk-child"></div>
          <div className="sk-circle3 sk-child"></div>
          <div className="sk-circle4 sk-child"></div>
          <div className="sk-circle5 sk-child"></div>
          <div className="sk-circle6 sk-child"></div>
          <div className="sk-circle7 sk-child"></div>
          <div className="sk-circle8 sk-child"></div>
          <div className="sk-circle9 sk-child"></div>
          <div className="sk-circle10 sk-child"></div>
          <div className="sk-circle11 sk-child"></div>
          <div className="sk-circle12 sk-child"></div>
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Loading;